import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVelocity = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "{size} ",
	height: "{size} ",
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	className: "{className} ",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_22943_8274)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M1.98181 11.6137C1.87574 11.0867 1.82271 10.5431 1.82271 9.99788C1.82271 9.45595 1.87574 8.91568 1.98015 8.38867C2.07793 7.8948 1.75807 7.41419 1.26421 7.31641C0.770337 7.21863 0.289727 7.53848 0.191948 8.03235C0.0643379 8.67538 -0.00195312 9.33663 -0.00195312 9.99788C-0.00195312 10.6624 0.0643379 11.3254 0.191948 11.97C0.278126 12.4026 0.6593 12.7026 1.08522 12.7026C1.14488 12.7026 1.20454 12.6959 1.26421 12.6843C1.75807 12.5849 2.07793 12.1059 1.97849 11.6121L1.98181 11.6137Z",
					fill: "{fill} "
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M5.52527 16.8447C4.61377 16.2464 3.83982 15.4858 3.22828 14.5842C2.94489 14.1682 2.3781 14.0588 1.96213 14.3422C1.54615 14.6256 1.43677 15.1908 1.72016 15.6084C2.46759 16.7121 3.41224 17.6402 4.52759 18.3711C4.68171 18.4722 4.85573 18.5202 5.02643 18.5202C5.32308 18.5202 5.61476 18.3744 5.79043 18.1076C6.0672 17.6866 5.94953 17.1215 5.52692 16.8447H5.52527Z",
					fill: "{fill} "
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M1.95906 5.66472C2.1165 5.77078 2.29383 5.82216 2.4695 5.82216C2.76118 5.82216 3.04955 5.68129 3.22522 5.4211C3.83675 4.51788 4.60904 3.75719 5.52055 3.15892C5.94149 2.88215 6.05916 2.31702 5.78239 1.89607C5.50563 1.47512 4.9405 1.35746 4.51955 1.63422C3.40586 2.36508 2.46121 3.29481 1.71544 4.39856C1.4337 4.81453 1.54143 5.38132 1.95906 5.66472Z",
					fill: "{fill} "
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M10.0069 0C10.0069 0 10.0019 0 10.0002 0C9.39201 0 8.78048 0.0546901 8.18717 0.16407C7.69165 0.25522 7.3635 0.729201 7.45466 1.22473C7.53586 1.6639 7.91869 1.97216 8.34958 1.97216C8.40427 1.97216 8.45896 1.96719 8.51531 1.95724C9.00089 1.86775 9.49973 1.823 9.99857 1.823H10.0002C14.5097 1.823 18.1772 5.49055 18.1772 10C18.1772 14.5094 14.5097 18.177 10.0002 18.177C9.50139 18.177 9.00255 18.1322 8.51531 18.0428C8.01813 17.9516 7.54581 18.2797 7.45466 18.7753C7.3635 19.2708 7.69165 19.7448 8.18717 19.8359C8.78213 19.9453 9.39201 20 10.0002 20C15.514 20 20.0002 15.5138 20.0002 10C20.0002 4.48624 15.5173 0.00331455 10.0069 0Z",
					fill: "{fill} "
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M8.11583 13.7667L13.7091 10.5069C14.082 10.2898 14.082 9.7097 13.7091 9.4926L8.11583 6.22942C7.76449 6.02558 7.33691 6.30234 7.33691 6.73821V13.2612C7.33691 13.6971 7.76449 13.9739 8.11583 13.7667Z",
					fill: "{fill} "
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_22943_8274",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 20,
				height: 20,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgVelocity);
export default ForwardRef;
